import { useNavigate } from 'react-router-dom';
import { Database, Calendar, BookOpen, GraduationCap, Wrench, UserCheck, ShoppingCart, FileText, AlertTriangle, Building2 } from 'lucide-react';

interface CatalogCard {
  id: string;
  title: string;
  description: string;
  icon: React.ComponentType<{ className?: string }>;
  path: string;
  color: string;
}

export default function Catalogos() {
  const navigate = useNavigate();

  const catalogs: CatalogCard[] = [
    {
      id: 'aulas',
      title: 'Aulas',
      description: 'Gestión de aulas y espacios académicos',
      icon: Database,
      path: '/app/catalogos/aulas',
      color: 'bg-blue-500'
    },
    {
      id: 'equipamientos',
      title: 'Equipamientos',
      description: 'Tipos de equipamiento para aulas',
      icon: Wrench,
      path: '/app/catalogos/equipamientos',
      color: 'bg-amber-500'
    },
    {
      id: 'materias',
      title: 'Materias',
      description: 'Catálogo de asignaturas y cursos',
      icon: BookOpen,
      path: '/app/catalogos/materias',
      color: 'bg-emerald-500'
    },
    {
      id: 'programas',
      title: 'Programas Académicos',
      description: 'Carreras y planes de estudio',
      icon: GraduationCap,
      path: '/app/catalogos/programas',
      color: 'bg-orange-500'
    },
    {
      id: 'periodos',
      title: 'Grupos y Períodos Académicos',
      description: 'Gestión de ciclos escolares y grupos',
      icon: Calendar,
      path: '/app/catalogos/periodos',
      color: 'bg-purple-500'
    },
    {
      id: 'profesores',
      title: 'Profesores',
      description: 'Gestión de profesores y materias que imparten',
      icon: UserCheck,
      path: '/app/catalogos/profesores',
      color: 'bg-teal-500'
    },
    {
      id: 'productos',
      title: 'Productos y Servicios',
      description: 'Catálogo de productos y servicios con contabilidad',
      icon: ShoppingCart,
      path: '/app/catalogos/productos',
      color: 'bg-rose-500'
    },
    {
      id: 'tramites',
      title: 'Trámites Académicos',
      description: 'Tipos de trámites con costos asociados',
      icon: FileText,
      path: '/app/catalogos/tramites',
      color: 'bg-indigo-500'
    },
    {
      id: 'categorias-problemas',
      title: 'Categorías de Problemas',
      description: 'Tipos de problemas para tickets de soporte',
      icon: AlertTriangle,
      path: '/app/catalogos/categorias-problemas',
      color: 'bg-red-500'
    },
    {
      id: 'empresas',
      title: 'Empresas (Razones Sociales)',
      description: 'Plan de cuentas y pólizas contables por empresa fiscal',
      icon: Building2,
      path: '/app/finance',
      color: 'bg-slate-600'
    }
  ];

  return (
    <div className="flex flex-col h-screen p-6 overflow-hidden">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Catálogos del Sistema</h1>
        <p className="text-gray-600 mt-2">Gestión de catálogos maestros del sistema escolar</p>
      </div>

      <div className="flex-1 overflow-y-auto pr-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 pb-6">
          {catalogs.map((catalog) => {
            const Icon = catalog.icon;
            return (
              <div
                key={catalog.id}
                onClick={() => navigate(catalog.path)}
                className="bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer transform hover:scale-105 overflow-hidden"
              >
                <div className={`${catalog.color} h-32 flex items-center justify-center`}>
                  <Icon className="h-16 w-16 text-white" />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">{catalog.title}</h3>
                  <p className="text-gray-600 text-sm">{catalog.description}</p>
                </div>
                <div className="px-6 pb-4">
                  <button className="text-blue-600 hover:text-blue-800 font-medium text-sm flex items-center">
                    Administrar →
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-6 bg-blue-50 border border-blue-200 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-blue-900 mb-2">💡 Información</h3>
          <p className="text-blue-800 text-sm">
            Los catálogos son la base del sistema. Configura correctamente estos datos maestros antes de comenzar con la operación académica.
          </p>
        </div>
      </div>
    </div>
  );
}
